import(/* webpackMode: "eager" */ "/app/app/[locale]/(dynamic)/blog/not-found.tsx");
